export const collectionInventoryByHandleQuery = `query CollectionInventoryQuery($handle: String!) {
    collectionInventory(handle: $handle) {
        products {
            product_id
            product_type
            inventory {
                id: admin_graphql_api_id
                inventory_quantity
                pre_order_inventory_quantity
                product_id
                sku
                options {
                    type
                    value
                }
            }
        }
    }
  }
    `
